import { render, staticRenderFns } from "./GlobalSelection.vue?vue&type=template&id=d2f1f6fa&scoped=true"
import script from "./GlobalSelection.vue?vue&type=script&lang=js"
export * from "./GlobalSelection.vue?vue&type=script&lang=js"
import style0 from "./GlobalSelection.vue?vue&type=style&index=0&id=d2f1f6fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f1f6fa",
  null
  
)

export default component.exports